var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"z-index":"2"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-crop-free ")]),_vm._v(" GISを表示 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }